import React, { useEffect } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession } from '../actions'
import { getUsers, setUsersFilter } from '../actions/users'
import { CustomPagination } from '../components/common/custom_pagination/custom_pagination'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import Spinner3Bounce from '../components/spinner_3_bounce'
import UserSearchBar from '../components/users/users-search-bar'
import UsersListComponent from '../components/users/users_list'

const Users = (props) => {
  const { errorMessage, isAuthenticated, isFetching, results, filter, pageHash, setUsersFilter } = props

  useEffect(() => {
    const page = getActivePage()
    props.getUsers({ ...filter, page })
    setUsersFilter({ ...filter, page })
  }, [])

  if (!isAuthenticated) {
    return null
  }

  const handleSelectPagination = (page, metaKey) => {
    if (metaKey) {
      props.navigateToPageInNewWindow(page)
    } else {
      props.getUsers({ ...filter, page })
      setUsersFilter({ ...filter, page })
      props.navigateToPage(page)
    }
  }

  const getActivePage = () => {
    const { pageHash } = props
    return pageHash ? parseInt(pageHash.split('/').pop(), 0) : 1
  }

  const onSelectUser = (user) => props.navigateToIdentity(user.id)

  return (
    <div className='animated fadeIn'>
      <DivTitleBox className='ibox-title'>
        <div className='row'>
          <div className='col-xs-9 col-sm-9'>
            <h2>Users</h2>
          </div>
          <div className='col-xs-3 col-sm-3 text-end'>
            <Button bsPrefix='btn btn-w-m btn-default' onClick={() => props.history.push('/users/add')}>
              <i className='fa fa-user-plus' /> Create User
            </Button>
          </div>
        </div>
      </DivTitleBox>
      <DivContentBox className='ibox-content'>
        <div>{errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}</div>
        <UserSearchBar />
        {isFetching ? (
          <div className='text-center grid-spinner-mt-240'>
            <Spinner3Bounce isActive />
          </div>
        ) : (
          <>
            {results && (
              <>
                <UsersListComponent data={results.results} onSelect={onSelectUser} />
                <div className='text-center'>
                  <CustomPagination
                    activePage={getActivePage()}
                    onPageChanged={handleSelectPagination}
                    totalRecords={results.count}
                    pageLimit={100}
                  />
                </div>
              </>
            )}
          </>
        )}
      </DivContentBox>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.getUsers.errorMessage,
  results: state.getUsers.results,
  isFetching: state.getUsers.isFetching,
  pageHash: ownProps.location.hash,
  navigateToIdentity: (id) => ownProps.history.push(`/users/${id}`),
  filter: state.usersFilter.filter,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      checkSession,
      setUsersFilter,
      getUsers,
      navigateToPage: (p) => ownProps.history.push(`#/page/${p}`),
      navigateToPageInNewWindow: (p) => {
        window.open(`#/page/${p}`, '_blank')
      },
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Users))
